import { KPI } from '@/hooks/useCampaigns';

export const formatKPI = (kpi: KPI): string => {
  return kpi.charAt(0).toUpperCase() + kpi.slice(1).toLowerCase();
};
